import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-78" data-mp="1gd7ioekfll8n">
      <div className="mx-auto w-full max-w-[820px]" data-id="element-79" data-mp="1gal2jqjh5xet">
        <Reveal data-id="element-80" data-mp="2dzem3l5017jf">
          <h2 className="text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-81" data-mp="2dzxt46t42bio">
            Ofte stillede spørgsmål
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-82" data-mp="240p31p1d9h1l">
          <div className="mt-12 divide-y divide-line border-y border-line" data-id="element-83" data-mp="24435sydxzs9k">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} data-id="element-84" data-mp="sl0ggys0yk1b" data-mpi={index}>
                  <h3 data-id="element-85" data-mp="nnidrq4lp11r">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex min-h-[64px] w-full items-center justify-between gap-5 px-1 py-5 text-left transition-colors duration-150 ease-out hover:text-red focus:outline-none focus-visible:ring-2 focus-visible:ring-navy" data-id="element-86" data-mp="nn8qiaaxx7zr">
                      <span className="text-base font-semibold text-navy sm:text-lg" data-id="element-87" data-mp="kko5nmmowtxm">
                        {faq.question}
                      </span>
                      <ChevronDownIcon className={`h-5 w-5 shrink-0 text-navy transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-88" data-mp="bj81hwmgxo1u" />
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-89" data-mp="3k0cerrbtv70i">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-90" data-mp="3o1o3lumvno7n">
                        <p className="px-1 pb-6 text-base leading-relaxed text-ink" data-id="element-91" data-mp="1ftjb3ug9urqg">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </section>;
}